<template>
  <div class="hw">
    <div class="bg"></div>
    <div class="text">Sungmoon Yoon</div>
  </div>
</template>

<script>
import Vue from "vue"

export default Vue.extend({})
</script>

<style lang="scss" scoped>
.hw {
  width: 100%;
  height: 300px;

  overflow: hidden;
  background-color: rgba(0, 0, 0, 1);
  .bg {
    height: 100%;
    background-image: url("../assets/bg.jpg");
    opacity: 0.5;
    background-size: cover;
    background-position: center;
    filter: blur(5px);
    transform: scale(1.05);
  }
  .text {
    position: absolute;
    top: 0;
    width: 100%;
    height: 300px;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }
}
</style>
